import { render, staticRenderFns } from "./ConsultaMasiva.vue?vue&type=template&id=b167c176"
import script from "./ConsultaMasiva.vue?vue&type=script&lang=js"
export * from "./ConsultaMasiva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports